module.exports = __webpack_public_path__ + "img/阴.e822205d.png";